function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.82755 0.479719C10.1566 0.622573 10.3522 0.965279 10.3077 1.32126L9.61306 6.878H15.9709C16.2844 6.878 16.5697 7.0594 16.7027 7.34337C16.8357 7.62733 16.7924 7.96261 16.5917 8.2035L8.51031 17.9012C8.28064 18.1768 7.89677 18.268 7.56768 18.1251C7.23859 17.9823 7.04308 17.6396 7.08758 17.2836L7.78217 11.7268H1.42436C1.11079 11.7268 0.825521 11.5454 0.692518 11.2615C0.559514 10.9775 0.602786 10.6422 0.80353 10.4013L8.88493 0.703668C9.1146 0.428065 9.49847 0.336865 9.82755 0.479719ZM3.14977 10.1106H8.69762C8.92942 10.1106 9.15006 10.2101 9.30346 10.3839C9.45687 10.5576 9.52827 10.7889 9.49952 11.0189L9.03327 14.7489L14.2455 8.49428H8.69762C8.46582 8.49428 8.24518 8.39475 8.09177 8.22097C7.93837 8.0472 7.86697 7.81592 7.89572 7.58591L8.36196 3.85593L3.14977 10.1106Z",
  fill: "#BDBDBD"
});

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 19,
    viewBox: "0 0 17 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0c081d39.svg";
export { ForwardRef as ReactComponent };